import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, Paper, Stack, TextField, Typography } from "@mui/material";
import { publicApi } from "../api";

const LABELS = { 1: "Very dissatisfied", 2: "Dissatisfied", 3: "Neutral", 4: "Satisfied", 5: "Very satisfied" };

export default function CsatPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    publicApi.csat(token).then((d) => {
      setInfo(d);
      if (d.responded) setDone(true);
      const r = Number(new URLSearchParams(window.location.search).get("r"));
      if (r >= 1 && r <= 5) setRating(r);
    }).catch((err) => setError(err?.response?.data?.message || "This survey link is not valid"));
  }, [token]);

  const submit = async () => {
    try {
      await publicApi.submitCsat(token, { rating, feedback });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.message || "Could not submit your rating");
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 480, width: "100%", borderRadius: "16px" }} elevation={0} variant="outlined">
        {error ? <Alert severity="error">{error}</Alert> : !info ? <CircularProgress size={24} /> : done ? (
          <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ fontSize: "2rem" }}>🙏</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "1.1rem" }}>Thank you for your feedback!</Typography>
            <Typography sx={{ color: "#667085", fontSize: "0.9rem", mt: 1 }}>{info.company}</Typography>
          </Box>
        ) : info.expired ? <Alert severity="info">This survey has expired.</Alert> : (
          <>
            <Typography sx={{ color: "#667085", fontSize: "0.85rem" }}>{info.company} · Ticket {info.ticketKey}</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "1.15rem", mt: 0.5, mb: 2 }}>How satisfied were you with our support?</Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "#475467", mb: 2 }}>{info.subject}</Typography>
            <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 1 }}>
              {[1, 2, 3, 4, 5].map((n) => (
                <Button key={n} onClick={() => setRating(n)} aria-label={`${n} stars`} sx={{ minWidth: 0, fontSize: "1.9rem", lineHeight: 1, filter: n <= rating ? "none" : "grayscale(1) opacity(.4)" }}>⭐</Button>
              ))}
            </Stack>
            <Typography sx={{ textAlign: "center", fontSize: "0.85rem", color: "#475467", minHeight: 20, mb: 2 }}>{LABELS[rating] || ""}</Typography>
            <TextField fullWidth multiline minRows={3} label="Anything you'd like to tell us? (optional)" value={feedback} onChange={(e) => setFeedback(e.target.value)} sx={{ mb: 2 }} />
            <Button fullWidth variant="contained" disabled={!rating} onClick={submit} sx={{ textTransform: "none", fontWeight: 700 }}>Submit</Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
